export default __webpack_public_path__ + "static/media/undraw_mission_impossible_bwa2.98768065.svg";